/* eslint-disable*/
//import Button from '@carbon/react/lib/components/Button/Button';
import { withWebChat } from '@ibm-watson/assistant-web-chat-react';
import React, { useEffect, useState } from 'react';

import CustomResponsePortalsContainer from './portalContainer';
import './webchat.scss';

const WebChat = ({ createWebChatInstance }) => {
  const [instance, setInstance] = useState(null);

  // We are going to save the message history here.
  let messages = [];

  /**
   * This function will save each message that is generated by the send and receive events.
   */
  function saveMessage(event) {
    const cl = [];
    messages.push(event.data);
    // console.log("messages : ", messages)
    messages.forEach((message) => {
      if (message && message['input'] && message['input']['text']) {
        if (message.history && message.history.label) {
          // console.log("Message History Label : ", message.history.label )
          cl.push('User: ' + message.history.label + '\r\n');
        }
        // This is a message that came from the user.
        cl.push('User: ' + message.input.text + '\r\n');
        // console.log("Chat Log After input : ", message.input.text)
        // console.log("Chat Log After input : ", cl.toString())
      } else if (
        message &&
        message['output'] &&
        message['output']['generic'] &&
        message['output']['generic'].length > 0
      ) {
        // This is a message that came from the assistant. It can contain an array of individual message items.
        message.output.generic.forEach((messageItem) => {
          if (messageItem.text) {
            cl.push(
              'ELI: ' + messageItem.text.replace(/<[^>]*>/g, '') + '\r\n'
            );
            // console.log("Chat Log After output : ", messageItem.text)
            // console.log("Chat Log After output : ", cl.toString())
            // console.log("Chat log join : ", cl.join(''))
          } else if (
            messageItem.title &&
            messageItem.options &&
            messageItem.options.length > 0
          ) {
            // console.log("Chat log after output w options : ", messageItem.title)
            messageItem.options.forEach((option, index) => {
              if (option.label) {
                // console.log("Chat log output option : ", option.label, "index : ", index)
                cl.push('Option ' + (index + 1), ': ', option.label);
              }
            });
          }
        });
      }
    });
  }

  /**
   * This function will save all the messages that came from session history. These are messages that are loaded if
   * the web page is re-loaded or the user navigates to a different page in the middle of a conversation.
   */
  function saveHistory(event) {
    messages.push(...event.messages);
  }

  /**
   * This function will perform a download of the user's chat history. This is called when the user chooses the
   * custom option from the menu.
   */
  function doDownload() {
    const downloadContent = createDownload();

    const blob = new Blob([downloadContent], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);

    // To automatically trigger a download, we have to create a fake "a" element and then click it.
    const timestamp = new Date()
      .toISOString()
      .replace(/[_:]/g, '-')
      .replace(/.[0-9][0-9][0-9]Z/, '');
    const a = document.createElement('a');
    a.setAttribute('href', url);
    a.setAttribute('download', `Chat History ${timestamp}.csv`);
    a.click();
  }

  /**
   * This function will be called when the user selects the "Download history" custom menu option.
   */
  function createDownload() {
    // We're going to create a comma-separate-value file (CSV). The first column will indicate if the message came
    // from the user or if it came from teh bot. The second column will be the text of the message. This code here
    // only supports text responses but it can be updated to support additional types of messages such as "option"
    // responses (buttons and dropdowns) or "connect_to_agent" response. You can find more information about the
    // possible types of responses here: https://cloud.ibm.com/apidocs/assistant/assistant-v2#message-response.
    const downloadLines = [createDownloadText('From', 'Message')];

    messages.forEach((message) => {
      if (message?.history?.label && message?.input?.text) {
        //Handling options
        downloadLines.push(createDownloadText('You', message.history.label));
      } else if (message?.input?.text) {
        // This is a message that came from the user.
        downloadLines.push(createDownloadText('You', message.input.text));
      } else if (message?.output?.generic?.length) {
        // This is a message that came from the assistant. It can contain an array of individual message items.
        message?.output?.generic.forEach((messageItem) => {
          // This is only handling a text response but you can handle other types of responses here as well as
          // custom responses.
          if (messageItem?.text) {
            downloadLines.push(
              createDownloadText(
                'ELI',
                messageItem.text.replace(/<[^>]*>/g, '')
              )
            );
          } else if (messageItem?.title && messageItem?.options?.length > 0) {
            downloadLines.push(createDownloadText('ELI', messageItem.title));
            messageItem.options.forEach((option, index) => {
              if (option.label) {
                downloadLines.push(
                  createDownloadText('Option ' + (index + 1), option.label)
                );
              }
            });
          }
        });
      }
    });

    return downloadLines.join('\n');
  }

  /**
   * Escapes the given piece of text so it can safely be displayed in a CSV file.
   */
  function escapeCSV(text) {
    // Remove any newline characters which aren't supported in all CSV formats.
    text = text.replace(/\n/g, ' ');

    // If the text contains a comma or a double quote, the entire thing needs to be surrounded by double quotes. If
    // the string contains a double quote, then each double quote needs to be replaced with two double quotes.
    if (text.match(/[,"]/)) {
      return `"${text.replace(/"/g, '""')}"`;
    }
    return text;
  }

  /**
   * Creates a single row of text that will appear in the output file.
   */
  function createDownloadText(from, text) {
    return `${from},${escapeCSV(text)}`;
  }

  /**
   * Following the v2 message API Response
   * at https://cloud.ibm.com/apidocs/assistant/assistant-v2#send-user-input-to-assistant,
   * we add some items to context.
   */
  function preSendhandler(event) {
    // Check In User Defined Object
    let UserDefined = {};

    // Check For User Defined
    if (event?.data?.context?.skills?.['main skill']?.user_defined) {
      UserDefined = event.data.context.skills['main skill'].user_defined;
    }

    // Create Assistant Id From String
    if (UserDefined?.conversation_node) {
      // Create Context Variable From Context Variable
      let Context;
      if (UserDefined?.conversation_node?.context) {
        Context = {
          ...event.data.context.skills['main skill'].user_defined
            .conversation_node.context,
        };
      } else {
        Context = {};
      }

      // Create User Defined Context Variable From Context Variable
      let UserDefinedContext;
      if (
        UserDefined?.conversation_node?.context?.skills?.['main skill']
          ?.user_defined
      ) {
        UserDefinedContext = {
          ...event.data.context.skills['main skill'].user_defined
            .conversation_node.context.skills['main skill'].user_defined,
        };
      } else {
        UserDefinedContext = {};
      }

      // Check In Results Array
      let chat_log = [];

      // Extract Message Log
      messages.forEach((message) => {
        if (message?.input?.text) {
          if (message?.history?.label) {
            chat_log.push('User: ' + message.history.label + '\r\n');
          } else {
            // This is a message that came from the user.
            chat_log.push('User: ' + message.input.text + '\r\n');
          }
        } else if (message?.output?.generic?.length > 0) {
          // This is a message that came from the assistant. It can contain an array of individual message items.
          message.output.generic.forEach((messageItem) => {
            if (messageItem?.text) {
              chat_log.push(
                'ELI: ' + messageItem.text.replace(/<[^>]*>/g, '') + '\r\n'
              );
              // console.log("Chat Log After output : ", chat_log.toString())
              // console.log("Chat log join : ", chat_log.join(''))
            } else if (messageItem?.title && messageItem?.options?.length > 0) {
              // console.log("Chat log after output w options : ", messageItem.title)
              chat_log.push('ELI: ' + messageItem.title + '\r\n');
              messageItem.options.forEach((option, index) => {
                if (option?.label) {
                  // console.log("Chat log output option : ", option.label)
                  chat_log.push(
                    'Option ' + (index + 1) + ': ' + option.label + '\r\n'
                  );
                }
              });
            }
          });
        }
      });

      // Create Context Object
      event.data.context = {
        skills: {
          'main skill': {
            user_defined: {
              assistant_id: process.env.BOARD_ASSISTANT_ID, //`${"8e82a295-9130-4ef5-874f-33c021018c19"}`,
              conversation_node: {
                context: {
                  ...Context,
                  skills: {
                    'main skill': {
                      user_defined: {
                        ...UserDefinedContext,
                        chat_log: chat_log,
                      },
                    },
                  },
                },
              },
            },
          },
        },
      };
    } else {
      // Create Context Object
      event.data.context = {
        skills: {
          'main skill': {
            user_defined: {
              assistant_id: process.env.BOARD_ASSISTANT_ID, //`${'8e82a295-9130-4ef5-874f-33c021018c19'}`,
            },
          },
        },
      };
    }
  }

  function createInstance() {
    const webChatOptions = {
      integrationID: process.env.INTEGRATION_ID, //'aecf1d55-2111-4939-a9b6-c81526c2e337', // The ID of this integration.
      region: process.env.REGION, //'us-south', // The region your integration is hosted in.
      serviceInstanceID: process.env.SERVICE_INSTANCE_ID, //'1283e2e7-7818-49bf-b327-d05c6d4a12d2', // The ID of your service instance.
      serviceDeskFactory: window.WebChatServiceDeskFactory,
      showLauncher: false,
      clientVersion: '6.4.0',
      showCloseAndRestartButton: true,
    };

    createWebChatInstance(webChatOptions).then((instance) => {
      setInstance(instance);
      onWebChatLoad(instance);
    });
  }
  function onWebChatLoad(instance) {
    // Listen for the send and receive events which will allow us to save the history so it can be downloaded later.
    // See https://web-chat.global.assistant.watson.cloud.ibm.com/docs.html?to=api-events#summary for more
    // about our events.
    instance.on({ type: 'send', handler: saveMessage });
    instance.on({ type: 'receive', handler: saveMessage });
    instance.on({ type: 'history:begin', handler: saveHistory });
    instance.on({ type: 'pre:send', handler: preSendhandler });

    // Add the custom menu option the user can use.
    instance.updateCustomMenuOptions('bot', [
      { text: 'Download history', handler: doDownload },
    ]);

    // Select the button element from the page.
    const button = document.querySelector('.chatLauncher');

    // Add the event listener to open your web chat.
    button.addEventListener('click', function clickListener() {
      instance.openWindow();
    });

    // Render the web chat. Nothing appears on the page, because the launcher is
    // hidden and the web chat window is closed by default.
    instance.render().then(function () {
      // Now that web chat has been rendered (but is still closed), we make the
      // custom launcher button visible.
      button.style.display = 'block';
      button.classList.add('open');
    });
  }

  // Load assistant
  useEffect(() => {
    createInstance();
  }, []);

  return (
    <div>
      {instance && <CustomResponsePortalsContainer instance={instance} />}
    </div>
  );
};

export default withWebChat()(WebChat);
